import {
  Box,
  Button,
  Typography,
  Card,
  CardContent,
  CardActions,
  Grid,
  Chip,
} from '@mui/material'
import { useLoaderData, useNavigate } from 'react-router-dom'
import PageAppBar from 'components/PageAppBar'
import { BadgeModel } from 'types'
import axios from 'axios'
import { base_url } from 'env'

export default function BadgePreviewPage() {
  const navigate = useNavigate()
  const badge = useLoaderData() as BadgeModel

  const handleDelete = () => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer ce badge ?`)) {
      const token = localStorage.getItem('token')
      axios
        .delete(`${base_url}/badge/${badge.id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then(() => {
          alert('Badge supprimé avec succès.')
          navigate('/badges')
        })
        .catch((err) => {
          console.error('La suppression a échoué:', err)
          alert('La suppression a échoué.')
        })
    }
  }

  return (
    <PageAppBar pageName={`Badge: ${badge.name}`}>
      <Box
        sx={{
          p: 3,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Card sx={{ width: '100%', maxWidth: '800px' }}>
          <CardContent>
            <Typography variant="h4" component="h1" gutterBottom>
              {badge.name}
            </Typography>
            <Typography variant="body1" color="text.secondary" paragraph>
              {badge.description}
            </Typography>

            <Grid container spacing={2} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <Chip
                  label={`ID: ${badge.id}`}
                  variant="outlined"
                  sx={{ width: '100%', justifyContent: 'flex-start', p: 1 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Chip
                  label={`Condition: ${badge.unlockCondition}`}
                  variant="outlined"
                  color="primary"
                  sx={{ width: '100%', justifyContent: 'flex-start', p: 1 }}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Chip
                  label={`Valeur: ${badge.unlockValue}`}
                  variant="outlined"
                  color="secondary"
                  sx={{ width: '100%', justifyContent: 'flex-start', p: 1 }}
                />
              </Grid>
              {badge.unlockAuxilliaryValue && (
                <Grid item xs={12}>
                  <Chip
                    label={`Valeur Auxiliaire: ${badge.unlockAuxilliaryValue}`}
                    variant="outlined"
                    sx={{ width: '100%', justifyContent: 'flex-start', p: 1 }}
                  />
                </Grid>
              )}
            </Grid>
          </CardContent>
          <CardActions>
            <Button
              size="small"
              onClick={() => navigate(`/badge/${badge.id}/edit`)}
            >
              Modifier
            </Button>
            <Button size="small" color="error" onClick={handleDelete}>
              Supprimer
            </Button>
          </CardActions>
        </Card>
      </Box>
    </PageAppBar>
  )
}
